import {Box, Button, Grid, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography} from "@mui/material";
import {grey} from "@mui/material/colors";
import {IconPlus} from "@tabler/icons-react";
import {useContext, useEffect, useMemo, useState} from "react";
import {CreateMemberModal} from "./components/add-project-member";
import {ProjectMemberItem} from "./components/project-member-item";
import {Context as AppContext} from "../../../context/AppContext";
import {toast} from "react-toastify";


export const ProjectMembersPage = ({project}) => {
  const {updateProject} = useContext(AppContext);
  const [addMember, setAddMember] = useState(false);
  const [members, setMembers] = useState([]);

  useEffect(() => {
    setMembers(project?.members || []);
  }, [project?.members]);

  const handleSave = () => {
    const vdnManager = project?.vdnManager || {};
    const team = members?.map(i => i?.username) || [];
    members?.forEach(member => {
      vdnManager[member?.username] = member?.vdn;
    })

    const newProject = {...project, members, team, vdnManager};
    try {
      updateProject({...newProject})
      toast.success("Project updated successfully")
    } catch (error) {
      toast.error(error?.message || "Failed to update project")
    }
  }

  const hasMemberChangesIncludingRemoved = (original, updated) => {
    const originalMap = Object.fromEntries(original.map(m => [m.username, m]));
    const updatedMap = Object.fromEntries(updated.map(m => [m.username, m]));

    // Check added or modified
    const changed = updated.some(member => {
      const orig = originalMap[member.username];
      return !orig || orig.vdn !== member.vdn || orig.role !== member.role;
    });

    // Check removed
    const removed = original.some(member => !updatedMap[member.username]);

    return changed || removed;
  };

  const hasChanges = useMemo(() => {
    return hasMemberChangesIncludingRemoved(project?.members || [], members);
  }, [members, project?.members])

  return (
    <>
      <CreateMemberModal open={addMember} handleClose={() => setAddMember(false)} project={project} />
      <Grid container maxWidth={"xl"} spacing={2} sx={{mx: "auto", p: {xs: 2, md: 4}, overflowY: "auto"}}>
        <Grid item xs={12}>
          <Stack direction={"row"} gap={1} justifyContent={"space-between"}>
            <Box>
              <Typography fontWeight={700} fontSize={"1.05em"} gutterBottom>Members</Typography>
              <Typography fontWeight={400} color={grey[600]} variant="body2" fontSize="0.85em">
                Project access is granted to members, each with a specific role.
              </Typography>
            </Box>
            <Box>
              <Button onClick={() => setAddMember(true)} startIcon={<IconPlus size={18}/>} color={'secondary'}
                      variant={"modal"} sx={{borderRadius: "8px"}}>
                Add Member
              </Button>
            </Box>
          </Stack>
        </Grid>

        <Grid item xs={12}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{fontWeight: 500}}>Name</TableCell>
                <TableCell sx={{fontWeight: 500}}>VDN</TableCell>
                <TableCell sx={{fontWeight: 500}}>Role</TableCell>
                <TableCell padding={"checkbox"} sx={{fontWeight: 500}}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {members?.map(i => <ProjectMemberItem key={i?.username} member={i} setMembers={setMembers} />)}
            </TableBody>
          </Table>
        </Grid>
        <Grid item xs={12}>

          <Stack direction={"row"} gap={2} alignItems={"center"} justifyContent={"flex-end"}>
            <Button disabled={!hasChanges} variant={"ghost"} color={"secondary"} onClick={() => setMembers(project?.members || [])}>Reset</Button>
            <Button disabled={!hasChanges} variant={"modal"} color={"secondary"} onClick={handleSave}>
              Save
            </Button>
          </Stack>
        </Grid>
      </Grid>

    </>
  )
}